function onCheckoutComplete(e) {
  if (__DEV__) {
    console.log('Web.Zephr:event: onCheckoutComplete', e);
  }

  // Unmount all outcomes because they are remounted
  dispatchEvent(new CustomEvent('onzephrunmountalloutcomes'));

  return;
}

export default onCheckoutComplete;
